/**
 * Print receipt HTML from the current page.
 * A hidden frame keeps the browser print dialog here — no extra tab.
 * Images are waited on so the company logo is in the preview.
 */
export function openHtmlPrintWindow(html) {
  const iframe = document.createElement('iframe');
  iframe.setAttribute('aria-hidden', 'true');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  document.body.appendChild(iframe);

  const frameWindow = iframe.contentWindow;
  const frameDoc = frameWindow.document;
  frameDoc.open();
  frameDoc.write(html);
  frameDoc.close();

  let printed = false;
  const cleanup = () => {
    if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
  };
  const startPrint = () => {
    if (printed) return;
    printed = true;
    frameWindow.focus();
    frameWindow.addEventListener('afterprint', cleanup, { once: true });
    frameWindow.print();
    setTimeout(cleanup, 60000);
  };

  const images = Array.from(frameDoc.images || []);
  const pending = images.filter((img) => !img.complete);
  if (!pending.length) {
    startPrint();
    return true;
  }

  let left = pending.length;
  const done = () => {
    left -= 1;
    if (left <= 0) startPrint();
  };
  pending.forEach((img) => {
    img.addEventListener('load', done);
    img.addEventListener('error', done);
  });
  setTimeout(startPrint, 2000);
  return true;
}
